var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.072 8.24h15.192V6.848H3.072l5.856-5.832L7.944.08.48 7.544l7.464 7.464.96-.936L3.072 8.24z",
    fill: "#FEFEFE"
  }))));
}
export default SvgBackArrowinline;